import React, { useEffect, useRef, useState } from 'react';
import './leaders-list.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { useLocation, useNavigate } from 'react-router-dom';
import { sortPlayers } from '@/utils/sortPlayers';
import { useSelector } from 'react-redux';

const LeadersList = ({
  gameData,
  playerList,
  role
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [playersToDisplay, setPlayersToDisplay] = useState(null);
  const [containerHeight, setContainerHeight] = useState(0);
  const [moreLeaders, setMoreLeaders] = useState(false);
  const navigate = useNavigate();
  const endRef = useRef(20);
  const location = useLocation();

  useEffect(() => {
    const el = document.getElementById('leader-card');
    if (!el) return;
    const height = el.offsetHeight;
    setContainerHeight(height - 84);
  }, [])

  useEffect(() => {
    if (
      screenSize === 'mobile' ||
      screenSize === 'tablet'
    ) {
      setContainerHeight(250);
    }
  }, [screenSize])

  useEffect(() => {
    if (!gameData || !playerList) return;
    displayLeaders();
  }, [gameData, playerList])

  function displayLeaders() {
    let sort = gameData.sortLeaders ?? 'points';
    // const sortedPlayers = sortPlayers({
    //     'playerList': playerList, 
    //     'sortBy': sort,
    //     'filter': 'players'
    // });

    const sortedPlayers = Object.values(playerList)
      .filter(p => p.status === 'active' && !p.team)
      .sort((a, b) =>
        b[sort] !== a[sort]
          ? b[sort] - a[sort]
          : (a.displayName ?? '').toLowerCase() > (b.displayName ?? '').toLowerCase()
            ? 1
            : -1
      )

    let arr = []
    for (let p of sortedPlayers) {
      arr.push({
        'playerId': p.playerId,
        'icon': p.icon,
        'gradient': p.gradient,
        'fName': p.fName,
        'lName': p.lName ?? '',
        'displayName': p.displayName ?? '',
        'data': p[sort] ?? 0,
        'path': p.path
      })
    }
    setPlayersToDisplay(arr.slice(0, endRef.current));
    if (arr.length > endRef.current) {
      setMoreLeaders(true);
    } else {
      setMoreLeaders(false);
    }
  }

  function loadMore() {
    endRef.current += 20;
    displayLeaders();
  }

  return (
    <div className='leaders-list'>
      <div className='list-container' style={{ 'height': `${containerHeight}px` }}>
        {
          (playersToDisplay) &&
          playersToDisplay.map((p, index) => (
            <button
              key={p.playerId}
              className='g-button text-only leaders-list-item'
              onClick={() =>
                (role !== 'owner' && role !== 'manager')
                  ?
                  null
                  :
                  navigate(`${location.pathname}/players/${p.path}`)}
            >
              <div className='meta'>{index + 1}</div>
              <div className='icon-div'>
                {
                  (p.icon)
                    ?
                    <ImageContainer src={p.icon} justifyContent='flex-start' />
                    :
                    <div className='gradient' style={{ 'background': p.gradient }}>{p.fName[0]}</div>
                }
              </div>
              <div className='meta left'>
                {p.displayName}
              </div>
              <div className='meta'>
                {p.data.toLocaleString()}
              </div>
            </button>
          ))
        }
        {
          (moreLeaders) &&
          <div className='center-col'>
            <button
              className='g-button small-btn'
              onClick={() => loadMore()}
            >
              Load More...
            </button>
          </div>
        }
      </div>
    </div>
  )
}

export default LeadersList